import React from 'react';
import { GOAL_AUTO_COLOR } from '../utils/goalCard';

/**
 * The two marks a goal carries (2026-10): ⚡ = the LMS counts it by itself,
 * ✎ = the student adds solved questions by hand. Same shapes as the mobile
 * app's lucide Zap / PenLine.
 */
export const AutoMark: React.FC<{ size?: number; title?: string }> = ({ size = 14, title = 'Otomatik sayılır' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={GOAL_AUTO_COLOR} stroke={GOAL_AUTO_COLOR} strokeWidth="1.5" strokeLinejoin="round" role="img" aria-label={title} className="flex-shrink-0">
    <title>{title}</title>
    <path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z" />
  </svg>
);

export const ManualMark: React.FC<{ size?: number; title?: string }> = ({ size = 14, title = 'Elle eklenir' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" role="img" aria-label={title} className="flex-shrink-0">
    <title>{title}</title>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
  </svg>
);
